/**
 * Created by jiachenpan on 16/11/18.
 */
import Vue from "vue";
import request from "@/utils/request";
import { getUserInfoByIdList } from "@/api/login";
const Base64 = require("js-base64").Base64;

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0;
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1;
    } else {
      len += 0.5;
    }
  }
  return Math.floor(len);
}

export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

export function param(json) {
  if (!json) return "";
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return "";
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
  ).join("&");
}

export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
}

export function html2Text(val) {
  const div = document.createElement("div");
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

export function objectMerge(target, source) {
  /* Merges two  objects,
       giving the last one precedence */

  if (typeof target !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

export const pickerOptions = [
  {
    text: "今天",
    onClick(picker) {
      const end = new Date();
      const start = new Date(new Date().toDateString());
      end.setTime(start.getTime());
      picker.$emit("pick", [start, end]);
    }
  },
  {
    text: "最近一周",
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit("pick", [start, end]);
    }
  },
  {
    text: "最近一个月",
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit("pick", [start, end]);
    }
  },
  {
    text: "最近三个月",
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit("pick", [start, end]);
    }
  }
];

export function getTime(type) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "shallowClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

export function createUniqueString() {
  const timestamp = +new Date() + "";
  const randomNum = parseInt((1 + Math.random()) * 65536) + "";
  return (+(randomNum + timestamp)).toString(32);
}

export function getUrlKey(keyname) {
  const reg = new RegExp("(^|&)" + keyname + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  } else {
    return null;
  }
}
export function getUserNameEmail(keys, responseData, type) {
  // Base64是所有需求需要处理id加密跳转
  return new Promise(function(resolve, reject) {
    // 做一些异步操作
    let array = [];
    array = responseData.map(item => {
      let str = "";
      keys.forEach(i => {
        if (item[i]) {
          if (typeof item[i] === "number" && item[i]) {
            str += item[i] + ",";
          } else {
            if (item[i].length > 0) {
              str += item[i].join(",") + ",";
            }
          }
        }
      });
      return str;
    });
    // 所有需要人名和邮箱的数组
    let allIds = Array.from(new Set([...array.join(",").split(",")]));
    allIds = allIds.filter(item => item);
    // 查所有人名和邮箱
    getUserInfoByIdList({
      userIds: allIds
    }).then(res => {
      const userData = res.data;
      responseData.forEach(s => {
        if (type === "Base64") {
          s.Base64_demand_id = Base64.encode(s.demand_id);
        }
        keys.forEach(k => {
          if (s[k]) {
            if (typeof s[k] === "number") {
              // id是数字。 人名  邮箱  存在_name
              const obj = userData.find(u => s[k] === u.userId);
              if (obj) {
                s[k + "_name"] = obj.name || "";
                s[k + "_email"] = obj.email || "";
              } else {
                s[k + "_name"] = "";
                s[k + "_email"] = "";
              }
            } else if (s[k] instanceof Array) {
              // id是数组的。
              s[k + "_name"] = [];
              s[k + "_email"] = [];
              s[k] = Array.from([...new Set(s[k])]);
              s[k].forEach(kk => {
                const obj = userData.find(u => kk === u.userId);
                if (obj) {
                  s[k + "_name"].push(obj.name);
                  s[k + "_email"].push(obj.email);
                }
              });
            } else {
            }
          }
        });
      });
      resolve(responseData);
    });
  });
}

export function deleteNullKey(values) {
  // value为对象
  Object.keys(values).map(item => {
    if (!values[item] && values[item] !== 0) {
      delete values[item];
    }
    return true;
  });
}
Vue.prototype.$deleteNullKey = deleteNullKey;

// blob数据格式转换
Vue.prototype._downBlob = (data, fileName) => {
  // const type = 'application/vnd.ms-excel' // 头部数据类型
  // const blob = new Blob(['\ufeff' + data], { type: type })
  // const blob = new Blob([data])
  const blob = new Blob([data], { type: "application/vnd.ms-excel" });
  if ("download" in document.createElement("a")) {
    // 非IE下载
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName);
  }
};
export const getCurrentTime = () => {
  return (
    (new Date().getHours() >= 10
      ? new Date().getHours()
      : "0" + new Date().getHours()) +
    ":" +
    (new Date().getMinutes() >= 10
      ? new Date().getMinutes()
      : "0" + new Date().getMinutes()) +
    ":" +
    (new Date().getSeconds() >= 10
      ? new Date().getSeconds()
      : "0" + new Date().getSeconds())
  );
};
/*
  导出表格
  @param {String} url 请求地址
  @param {Object} params 请求参数
  @param {String} fileName 文件名
*/
export const exportTable = (url, data, fileName) => {
  return new Promise((resolve, reject) => {
    request({
      url: url,
      method: "post",
      data,
      responseType: "blob"
    }).then(res => {
      const data = res;
      const blob = new Blob([data], { type: "application/vnd.ms-excel" });
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
      resolve(res);
    });
  });
};

// localStorage存储，查询和写入方法，tag=1为写入，2为查询
export const localStorageFn = (id,tag,data)=> {
  if (tag === 1) {
    localStorage.setItem(id, JSON.stringify(data));
  } else if (tag === 2) {
    return JSON.parse(localStorage.getItem(id));
  }
};
